import * as React from "react";
import {Component} from "react";
import {useLocation} from "react-router-dom";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {useUiVersion} from "../../context/UserModulesContext";
import {isAgencyPage} from "../layout/v2/agencyPages";

class AgencyHeaderClassic extends Component {
    constructor(props) {
        super(props);
        this.state = {
            'name': '',
        };
    }

    componentDidMount() {
        this.updateLinkedAccounts();
    }

    updateLinkedAccounts() {
        new APIClient(API_URL + 'get-agency-data/').call('GET').then((response) => {
            if (response.status === 'ERROR_NO_AGENCY') {
                alert(response.error_message);
                this.redirectToAgencyRegisterPage()
            } else if (response.status === 'OK') {
                this.setState({
                    'name': response.general_data.name,
                });
            }
        })
    }

    redirectToAgencyRegisterPage() {
        window.location.href = '/agency-register';
    }

    render() {
        return (
            <header className="section-header">
                <h1 className="section-title">{this.state.name}</h1>
            </header>
        );
    }
}

/**
 * El nombre de la agencia como título gigante de la pantalla. En la 2.1 no va en las pantallas de la
 * agencia (tanda «Agencia 2.1», D2): la miga ya dice dónde se está y las solapas pasan a ser la 2.ª
 * fila del topbar, como en la ficha del cliente. Fuera de la agencia (`UserSettings`) y en el
 * clásico, el de siempre.
 *
 * En la 2.1 tampoco corre su pedido a `get-agency-data/`: el nombre no se muestra, y quien tiene la
 * 2.1 tiene agencia (la 2.1 es un flag de la agencia), así que el rebote a `/agency-register` del
 * `ERROR_NO_AGENCY` no tiene a quién alcanzar.
 */
export function AgencyHeader(props) {
    const {isV2} = useUiVersion();
    const {pathname} = useLocation();
    if (isV2 && isAgencyPage(pathname)) return null;
    return <AgencyHeaderClassic {...props}/>;
}
